// @flow
import React from 'react'

import AbstractFormField from './AbstractFormField'
import { CheckboxTile } from '../../../Components/'

// types
import type { AssociatedFieldType } from '../../Types/ProductContent'
import type { DefaultFormFieldType, DefaultFormFieldState } from './AbstractFormField'

type CheckboxAssociationPropsType = DefaultFormFieldType & {
  associatedField: AssociatedFieldType,
  name: string,
}

/**
 * Component for rendering checkbox
 * @example ./docs/CheckboxAssociation.md
 */
export default class CheckboxAssociation extends AbstractFormField<CheckboxAssociationPropsType, DefaultFormFieldState> {

  handleOnchange = (checked: boolean, name: string) => {
    this.props.onChange(checked, name)
  }

  render() {
    const { associatedField, prefix, formData, onBlur } = this.props

    return (
      <div className='row'>
        {associatedField.items.map((item) => (
          <CheckboxTile
            checked={formData && !!formData[item.name]}
            icon={associatedField.icons ? associatedField.icons[item.name] : ''}
            key={`${prefix}-${item.name}`}
            label={associatedField.labels[item.name]}
            name={item.name}
            onBlur={onBlur}
            onChange={(checked) => {
              this.handleOnchange(checked, item.name)
            }}
          />))}
      </div>
    )
  }
}
